import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import {
  multitaxColumnDefs,
  nonMultitaxColumnDefs,
  creditColumnDefs,
  defCreditColumnDefs,
  stateAdjustmentColumnDefs,
} from '../../shared/columnDefinitions/drillDetail';

import AgGrid from '../../shared/agGrid/agGrid.component';
import DetailPopup from '../../shared/detailPopup.component';
import { specialReportLineTypes } from './constants';

import {
  isDrillDetailLoadingSelector,
  selectedEntryForDrillDetailSelector,
  drillDetailSelector,
} from './store/selectors';

class TaxExpenseDetails extends PureComponent {
  static propTypes = {
    isDrillDetailLoading: PropTypes.bool.isRequired,
    drillDetail: PropTypes.arrayOf(PropTypes.shape({
      account: PropTypes.string.isRequired,
      countryTaxType: PropTypes.string,
      disallowedAmt: PropTypes.number.isRequired,
      beginningBalance: PropTypes.number,
      ytdAmount: PropTypes.number,
      balance: PropTypes.number,
      disallowedPer: PropTypes.number,
      proportionOfTax: PropTypes.number,
      disallowedAmtTotal: PropTypes.number,
    })).isRequired,
    selectedEntry: PropTypes.shape({
      countryTaxType: PropTypes.string,
      columnTitle: PropTypes.string,
      reportLineType: PropTypes.string,
      groupItem: PropTypes.string,
      cellToElevateSelector: PropTypes.string,
    }).isRequired,
  };

  state = {
    preferredColumnDef: multitaxColumnDefs,
  };

  componentDidUpdate({ isDrillDetailLoading: wasDrillDetailLoading }) {
    const { isDrillDetailLoading, drillDetail } = this.props;

    if (wasDrillDetailLoading && !isDrillDetailLoading) {
      const isMultitax = drillDetail.some(row => row.proportionOfTax <= 1);

      if (isMultitax) {
        this.setState({ preferredColumnDef: multitaxColumnDefs });
      } else {
        this.setState({ preferredColumnDef: nonMultitaxColumnDefs });
      }
    }
  }

  render() {
    const {
      drillDetail,
      isDrillDetailLoading,
      selectedEntry,
    } = this.props;

    const { preferredColumnDef } = this.state;
    const getColumnDefs = reportLineType => {
      if (!Object.values(specialReportLineTypes).includes(reportLineType)) {
        return preferredColumnDef;
      }
      if (reportLineType === specialReportLineTypes.TOTAL_CREDITS) {
        return creditColumnDefs;
      } else if (reportLineType === specialReportLineTypes.TOTAL_DEFERRED_CREDITS) {
        return defCreditColumnDefs;
      } else {
        return stateAdjustmentColumnDefs;
      }
    };


    return (
      <DetailPopup
        id="taxExpenseDetails"
        title={selectedEntry.columnTitle}
        backdrop
        popupRootToElevateSelector={selectedEntry.cellToElevateSelector}
        className="ag-theme-bootstrap"
        size="lg"
      >
        <AgGrid
          columnDefs={getColumnDefs(selectedEntry.reportLineType)}
          rowData={drillDetail}
          isGridLoading={isDrillDetailLoading}
        />
      </DetailPopup>
    );
  }
}

function mapStateToProps(state) {
  return {
    drillDetail: drillDetailSelector(state),
    isDrillDetailLoading: isDrillDetailLoadingSelector(state),
    selectedEntry: selectedEntryForDrillDetailSelector(state),
  };
}

export default connect(mapStateToProps)(TaxExpenseDetails);
